import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

const PersonalInfo = ({ formData, handleChange }) => {
  return (
    <div>
      <h3 className="h5 mb-3">Personal Information</h3>
      
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="firstName">
            <Form.Label>First Name<span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="first_name"
              value={formData.patient.first_name}
              onChange={handleChange}
              required
              placeholder="Enter your first name"
            />
          </Form.Group>
        </Col>
        
        <Col md={6}>
          <Form.Group controlId="lastName">
            <Form.Label>Last Name<span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="last_name"
              value={formData.patient.last_name}
              onChange={handleChange}
              required
              placeholder="Enter your last name"
            />
          </Form.Group>
        </Col>
      </Row>
      
      <Form.Group controlId="email" className="mb-3">
        <Form.Label>Email Address<span className="text-danger">*</span></Form.Label>
        <Form.Control
          type="email"
          name="email"
          value={formData.patient.email}
          onChange={handleChange}
          required
          placeholder="email@example.com"
        />
      </Form.Group>
      
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="dob">
            <Form.Label>Date of Birth<span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="date"
              name="bio.date_of_birth"
              value={formData.patient.bio.date_of_birth}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
        
        <Col md={6}>
          <Form.Group controlId="gender">
            <Form.Label>Gender<span className="text-danger">*</span></Form.Label>
            <Form.Select
              name="bio.gender"
              value={formData.patient.bio.gender}
              onChange={handleChange}
            >
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="height">
            <Form.Label>Height (cm)</Form.Label>
            <Form.Control
              type="number"
              name="bio.height"
              value={formData.patient.bio.height}
              onChange={handleChange}
              placeholder="Height in cm"
            />
          </Form.Group>
        </Col>
        
        <Col md={6}>
          <Form.Group controlId="weight">
            <Form.Label>Weight (kg)</Form.Label>
            <Form.Control
              type="number"
              name="bio.weight"
              value={formData.patient.bio.weight}
              onChange={handleChange}
              placeholder="Weight in kg"
            />
          </Form.Group>
        </Col>
      </Row>
      
      <Form.Group controlId="race" className="mb-3">
        <Form.Label>Race</Form.Label>
        <Form.Select
          name="bio.race"
          value={formData.patient.bio.race}
          onChange={handleChange}
        >
          <option value="">Select race</option>
          <option value="Asian">Asian</option>
          <option value="Black or African American">Black or African American</option>
          <option value="Hispanic or Latino">Hispanic or Latino</option>
          <option value="Native American">Native American</option>
          <option value="White">White</option>
          <option value="Other">Other</option>
        </Form.Select>
      </Form.Group>
    </div>
  );
};

export default PersonalInfo;